import { render, staticRenderFns } from "./OrdersBaseView.vue?vue&type=template&id=0d1a6b96"
import script from "./OrdersBaseView.vue?vue&type=script&lang=js"
export * from "./OrdersBaseView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports